import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import CustomCursor from "./components/CustomCursor";
import ScrollToTop from "./components/ScrollToTop";
import LandingPage from "./pages/LandingPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import BacktestRequest from "./pages/BacktestRequest";
import ForecastAccuracy from "./pages/ForecastAccuracy";
import NotFoundPage from "./pages/NotFoundPage";

/** Block copy / cut / right-click outside of form inputs.
 *  CSS user-select:none handles selection; this is the hardening layer. */
function useNoCopy() {
  useEffect(() => {
    const isFormEl = (el) => {
      if (!el || !el.tagName) return false;
      const t = el.tagName.toLowerCase();
      if (t === "input" || t === "textarea" || t === "select") return true;
      if (el.isContentEditable) return true;
      return false;
    };
    const block = (e) => {
      if (!isFormEl(e.target)) e.preventDefault();
    };
    document.addEventListener("copy", block);
    document.addEventListener("cut", block);
    document.addEventListener("contextmenu", block);
    document.addEventListener("dragstart", block);
    return () => {
      document.removeEventListener("copy", block);
      document.removeEventListener("cut", block);
      document.removeEventListener("contextmenu", block);
      document.removeEventListener("dragstart", block);
    };
  }, []);
}

function App() {
  useNoCopy();
  return (
    <HelmetProvider>
      <BrowserRouter basename={process.env.PUBLIC_URL || "/"}>
        <ScrollToTop />
        <div className="App">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/backtest-request" element={<BacktestRequest />} />
            <Route path="/forecast-accuracy" element={<ForecastAccuracy />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <CustomCursor />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
